(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbb-music-player"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bbb-entry')) {
  customElements.define('bbb-entry', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const dialog = this.querySelector('dialog');
      const audio = this.querySelector('audio');
      const button = this.querySelector('.bbb-entry-button');
      const error = this.querySelector('.bbb-audio-error');
      const key = 'bbe-music-session-v1';
      let state = { entered: false, playing: false, time: 0, volume: 0.65 };
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (saved && saved.source === audio.getAttribute('src')) state = { ...state, ...saved };
      } catch {}
      let restoring = false;
      let leaving = false;
      let pendingSeek = false;
      const save = () => {
        if (!state.entered) return;
        if (!pendingSeek) state.time = audio.currentTime || 0;
        state.volume = audio.volume;
        try { sessionStorage.setItem(key, JSON.stringify({ ...state, source: audio.getAttribute('src') })); } catch {}
      };
      audio.volume = typeof state.volume === 'number' ? Math.min(1, Math.max(0, state.volume)) : 0.65;
      const seek = () => {
        if (Number.isFinite(state.time) && state.time > 0) {
          const duration = audio.duration;
          const time = Number.isFinite(duration) && duration > 0 ? state.time % duration : state.time;
          try { audio.currentTime = time; } catch {}
        }
        pendingSeek = false;
      };
      const play = () => {
        restoring = true;
        error.hidden = true;
        const playback = audio.play();
        if (playback) playback.then(() => { restoring = false; }).catch(() => {
          restoring = false;
          error.hidden = false;
        });
        else restoring = false;
      };
      button.addEventListener('click', () => {
        state.entered = true;
        state.playing = true;
        save();
        play();
        dialog.close();
        audio.focus();
      }, { signal });
      audio.addEventListener('play', () => {
        state.entered = true;
        state.playing = true;
        save();
      }, { signal });
      audio.addEventListener('playing', () => { error.hidden = true; }, { signal });
      audio.addEventListener('pause', () => {
        if (leaving || restoring) return;
        state.playing = false;
        save();
      }, { signal });
      audio.addEventListener('timeupdate', save, { signal });
      audio.addEventListener('volumechange', save, { signal });
      audio.addEventListener('seeked', save, { signal });
      audio.addEventListener('error', () => { error.hidden = false; }, { signal });
      window.addEventListener('pagehide', () => { leaving = true; save(); }, { signal });
      window.addEventListener('pageshow', event => {
        leaving = false;
        if (event.persisted && state.entered && state.playing && audio.paused) play();
      }, { signal });
      this.saveState = save;
      if (window.Shopify?.designMode) return;
      if (!state.entered) {
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          state.entered = true;
          state.playing = false;
          save();
          dialog.close();
        }, { signal });
        dialog.showModal();
      } else {
        pendingSeek = true;
        if (audio.readyState >= 1) {
          seek();
          if (state.playing) play();
        } else {
          audio.addEventListener('loadedmetadata', () => {
            seek();
            if (state.playing) play();
          }, { once: true, signal });
        }
      }
    }
    disconnectedCallback() {
      this.saveState?.();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
